




































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PdfjsViewer from './pdfjs-viewer.vue';

@Component({
  components: { PdfjsViewer }
})
export default class SecureFileViewer extends Vue {
  @Prop({ required: true }) visible!: boolean;
  @Prop({ required: true }) fileUrl!: string;
  @Prop({ default: "文件预览" }) title!: string;

  @Watch('visible')
  onVisibleChange(newVal: boolean) {
    if (newVal) {
      // 显示时启用安全模式
      document.body.classList.add('secure-mode');
    } else {
      // 隐藏时移除安全模式
      document.body.classList.remove('secure-mode');
    }
  }



  get isPdf() {
    return this.fileUrl && (
      this.fileUrl.toLowerCase().includes('.pdf') || 
      this.fileUrl.toLowerCase().includes('pdf')
    );
  }

  get isPpt() {
    return this.fileUrl && (
      this.fileUrl.toLowerCase().includes('.ppt') || 
      this.fileUrl.toLowerCase().includes('.pptx') ||
      this.fileUrl.toLowerCase().includes('ppt')
    );
  }

  get isWord() {
    return this.fileUrl && (
      this.fileUrl.toLowerCase().includes('.doc') || 
      this.fileUrl.toLowerCase().includes('.docx') ||
      this.fileUrl.toLowerCase().includes('doc')
    );
  }

  get isExcel() {
    return this.fileUrl && (
      this.fileUrl.toLowerCase().includes('.xls') || 
      this.fileUrl.toLowerCase().includes('.xlsx') ||
      this.fileUrl.toLowerCase().includes('excel')
    );
  }

  get isImage() {
    return this.fileUrl && (
      this.fileUrl.toLowerCase().includes('.jpg') || 
      this.fileUrl.toLowerCase().includes('.jpeg') ||
      this.fileUrl.toLowerCase().includes('.png') ||
      this.fileUrl.toLowerCase().includes('.gif') ||
      this.fileUrl.toLowerCase().includes('.bmp') ||
      this.fileUrl.toLowerCase().includes('.webp')
    );
  }

  get processedFileUrl() {
    if (!this.fileUrl) return '';
    
    if (this.isPdf) {
      // PDF参数：隐藏工具栏和导航
      const params = [
        'toolbar=0',
        'navpanes=0', 
        'scrollbar=1',
        'view=FitH',
        'zoom=85'
      ];
      
      const separator = this.fileUrl.includes('?') ? '&' : '#';
      return `${this.fileUrl}${separator}${params.join('&')}`;
    }
    
    if (this.isPpt || this.isWord || this.isExcel) {
      // Office文档使用Office在线查看器，添加参数隐藏工具栏
      const encodedUrl = encodeURIComponent(this.fileUrl);
      const officeOnlineUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}&wdAr=1.7777777777777777&wdEaaCheck=1&wdEaa=1&wdTab=0&wdbipreview=true`;
      
      // 备选方案：Google Docs查看器
      // const googleDocsUrl = `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`;
      
      return officeOnlineUrl;
    }
    
    return this.fileUrl;
  }



  handleClose() {
    // 移除安全模式
    document.body.classList.remove('secure-mode');
    this.$emit("close");
  }

  handleProtection(event: Event) {
    // 阻止任何可能导致文件泄露的操作
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  showSecurityWarning(event: Event) {
    // 阻止右键菜单和其他危险操作
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    // 显示安全警告
    // this.$message({
    //   message: '为保护文件安全，已禁用右键菜单和复制功能',
    //   type: 'warning',
    //   duration: 2000,
    //   showClose: false
    // });
    
    return false;
  }

  handleRightClick(event: MouseEvent) {
    // 检查是否是右键点击（button = 2）
    if (event.button === 2) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.showSecurityWarning(event);
      return false;
    }
    
    // 由于覆盖层已设置为pointer-events: none，滚动事件可以正常穿透
    // 不需要临时禁用覆盖层
    return true;
  }



  mounted() {
    // 添加全局事件监听
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('contextmenu', this.globalContextMenuHandler);
    document.addEventListener('selectstart', this.globalSelectHandler);
    document.addEventListener('copy', this.globalCopyHandler);
    document.addEventListener('cut', this.globalCutHandler);
    document.addEventListener('paste', this.globalPasteHandler);
    
    // 特别针对右键菜单的强制禁用
    document.addEventListener('contextmenu', this.forceDisableContextMenu, true);
    document.addEventListener('mousedown', this.preventRightClick, true);
    document.addEventListener('mouseup', this.preventRightClick, true);
    
    // 启用全局安全模式
    if (this.visible) {
      document.body.classList.add('secure-mode');
    }
    
    // 监听iframe加载完成，进一步禁用内部右键菜单
    this.$nextTick(() => {
      this.setupIframeProtection();
      
      // 为viewer-container添加右键事件监听
      const viewerContainer = this.$el.querySelector('.viewer-container');
      if (viewerContainer) {
        viewerContainer.addEventListener('contextmenu', this.showSecurityWarning, true);
        viewerContainer.addEventListener('mousedown', (e: Event) => this.handleRightClick(e as MouseEvent), true);
        viewerContainer.addEventListener('mouseup', (e: Event) => this.handleRightClick(e as MouseEvent), true);
      }
      
      // 为Office文档容器添加右键事件监听
      const officeContainer = this.$el.querySelector('.office-iframe-container');
      if (officeContainer) {
        officeContainer.addEventListener('contextmenu', this.showSecurityWarning, true);
        officeContainer.addEventListener('mousedown', (e: Event) => this.handleRightClick(e as MouseEvent), true);
        officeContainer.addEventListener('mouseup', (e: Event) => this.handleRightClick(e as MouseEvent), true);
      }
      
      // 为PDF容器添加右键事件监听
      const pdfContainer = this.$el.querySelector('.pdf-container');
      if (pdfContainer) {
        pdfContainer.addEventListener('contextmenu', this.showSecurityWarning, true);
        pdfContainer.addEventListener('mousedown', (e: Event) => this.handleRightClick(e as MouseEvent), true);
        pdfContainer.addEventListener('mouseup', (e: Event) => this.handleRightClick(e as MouseEvent), true);
      }
      
      // PDF embed右键拦截
      const pdfEmbed = this.$refs.pdfEmbed as HTMLElement | undefined;
      if (pdfEmbed) {
        pdfEmbed.addEventListener('contextmenu', this.showSecurityWarning, true);
        pdfEmbed.addEventListener('mousedown', (e: Event) => this.handleRightClick(e as MouseEvent), true);
      }
    });
  }

  beforeDestroy() {
    // 移除全局事件监听
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('contextmenu', this.globalContextMenuHandler);
    document.removeEventListener('selectstart', this.globalSelectHandler);
    document.removeEventListener('copy', this.globalCopyHandler);
    document.removeEventListener('cut', this.globalCutHandler);
    document.removeEventListener('paste', this.globalPasteHandler);
    
    // 移除强制禁用事件监听
    document.removeEventListener('contextmenu', this.forceDisableContextMenu, true);
    document.removeEventListener('mousedown', this.preventRightClick, true);
    document.removeEventListener('mouseup', this.preventRightClick, true);
    
    // 移除viewer-container的事件监听器
    const viewerContainer = this.$el?.querySelector('.viewer-container');
    if (viewerContainer) {
      viewerContainer.removeEventListener('contextmenu', this.showSecurityWarning, true);
      viewerContainer.removeEventListener('mousedown', (e: Event) => this.handleRightClick(e as MouseEvent), true);
      viewerContainer.removeEventListener('mouseup', (e: Event) => this.handleRightClick(e as MouseEvent), true);
    }
    
    // 移除Office文档容器的事件监听器
    const officeContainer = this.$el?.querySelector('.office-iframe-container');
    if (officeContainer) {
      officeContainer.removeEventListener('contextmenu', this.showSecurityWarning, true);
      officeContainer.removeEventListener('mousedown', (e: Event) => this.handleRightClick(e as MouseEvent), true);
      officeContainer.removeEventListener('mouseup', (e: Event) => this.handleRightClick(e as MouseEvent), true);
    }
    
    // 移除PDF容器的事件监听器
    const pdfContainer = this.$el?.querySelector('.pdf-container');
    if (pdfContainer) {
      pdfContainer.removeEventListener('contextmenu', this.showSecurityWarning, true);
      pdfContainer.removeEventListener('mousedown', (e: Event) => this.handleRightClick(e as MouseEvent), true);
      pdfContainer.removeEventListener('mouseup', (e: Event) => this.handleRightClick(e as MouseEvent), true);
    }
    
    // 确保移除安全模式
    document.body.classList.remove('secure-mode');
  }

  globalContextMenuHandler(event: Event) {
    if (this.visible) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.showSecurityWarning(event);
      return false;
    }
  }

  globalSelectHandler(event: Event) {
    if (this.visible) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  globalCopyHandler(event: Event) {
    if (this.visible) {
      this.showSecurityWarning(event);
    }
  }

  globalCutHandler(event: Event) {
    if (this.visible) {
      this.showSecurityWarning(event);
    }
  }

  globalPasteHandler(event: Event) {
    if (this.visible) {
      this.showSecurityWarning(event);
    }
  }

  forceDisableContextMenu(event: Event) {
    if (this.visible) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.showSecurityWarning(event);
      return false;
    }
  }

  preventRightClick(event: MouseEvent) {
    if (this.visible && event.button === 2) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.showSecurityWarning(event);
      return false;
    }
  }

  setupIframeProtection() {
    // 延迟执行，确保iframe和embed已加载
    setTimeout(() => {
      // 保护Office文档的iframe
      const iframes = document.querySelectorAll('.office-iframe');
      iframes.forEach((iframe: any) => {
        try {
          // 尝试为iframe内容添加右键禁用
          iframe.onload = () => {
            try {
              const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
              if (iframeDoc) {
                iframeDoc.addEventListener('contextmenu', (e: Event) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.showSecurityWarning(e);
                  return false;
                }, true);
              }
            } catch (error) {
              // 跨域限制，无法访问iframe内容
              console.log('无法访问iframe内容（跨域限制）');
            }
          };
        } catch (error) {
          console.log('iframe保护设置失败');
        }
      });
      
      // 保护PDF的embed标签
      const embeds = document.querySelectorAll('.secure-pdf-viewer');
      embeds.forEach((embed: any) => {
        try {
          // 为embed元素添加额外的右键禁用
          embed.addEventListener('contextmenu', (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            this.showSecurityWarning(e);
            return false;
          }, true);
          
          embed.addEventListener('selectstart', (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }, true);
          
          embed.addEventListener('dragstart', (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            this.showSecurityWarning(e);
            return false;
          }, true);
        } catch (error) {
          console.log('embed保护设置失败');
        }
      });
    }, 1000);
  }

  handleKeyDown(event: KeyboardEvent) {
    if (!this.visible) return;
    
    // 禁用所有可能泄露内容的快捷键
    const forbiddenKeys = [
      's', 'p', 'a', 'c', 'v', 'x', 'z', 'y', // Ctrl+组合键
      'F12', 'F1', 'F3', 'F5', // 功能键
    ];
    
    // 禁用Ctrl+组合键
    if (event.ctrlKey && forbiddenKeys.includes(event.key.toLowerCase())) {
      event.preventDefault();
      event.stopPropagation();
      
      const actionMap: Record<string, string> = {
        's': '保存',
        'p': '打印', 
        'a': '全选',
        'c': '复制',
        'v': '粘贴',
        'x': '剪切',
        'z': '撤销',
        'y': '重做'
      };
      
      const action = actionMap[event.key.toLowerCase()] || '该操作';
      this.$message.warning(`为保护文件安全，已禁用${action}功能`);
      return false;
    }
    
    // 禁用功能键
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
      event.stopPropagation();
      
      if (event.key === 'F12') {
        this.$message.warning('已禁用开发者工具');
      } else if (event.key === 'F5') {
        this.$message.warning('已禁用刷新功能');
      } else if (event.key === 'F3') {
        this.$message.warning('已禁用查找功能');
      }
      return false;
    }
    
    // 禁用Alt+组合键（可能打开浏览器菜单）
    if (event.altKey) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }
}
